<template>
  <b-row class="fs-12">
    <h6 class="pl-12 pt-20 fs-20 title-color">
      <b>Date and Time options</b>
    </h6>
    <b-row class="pt-18 mb-20">
      <b-col cols="12" class="fw-bold fs-13" align-self="center">
        Field Requirement.
      </b-col>
      <b-col align-self="center" class="fs-15">
        <b-form-checkbox @change="dateTimeData.required = !dateTimeData.required" v-model="dateTimeData.required" class="pl-0"> <span class="pl-25 text-align">Required</span> </b-form-checkbox><br />
      </b-col>
    </b-row>
    <b-row class="pb-12">
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" class="fw-bold fs-13 mt-30">
        Field Name
      </b-col>
      <b-col cols="12" class="pt-10 fs-15">
        You may name this field for the purposes of data mapping. It will not be visible to the Site Team(s) or participants.
      </b-col>
      <b-col cols="12 pt-12">
        <b-form-input type="text" v-model="dateTimeData.fieldName" placeholder="Enter field name" class="field-h40 form-control fs-15" size="sm" v-bind:class="{ 'is-danger': dateTimeData.fieldNameErrorMsg }" v-on:keyup.native="checkForErrors" autocomplete="off"></b-form-input>
        <span class="error-style" v-if="dateTimeData.fieldNameErrorMsg">{{ dateTimeData.fieldNameErrorMsg }}</span>
      </b-col>
    </b-row>
  </b-row>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import find from "lodash/find";

import schemas from "../../../data/form-components-json/schemas.json";

export default {
  name: "date-time-prop",
  components: {},
  data() {
    return {
      dateTimeData: [],
      choicesGiven: [],
      hideAddNotification: true,
      notifications: [],
      notificationSchema: find(schemas, "fieldType", "DateTime").schemas.notificationSchema
    };
  },
  props: ["dateTimeSchema"],
  mounted() {
    this.dateTimeData = this.dateTimeSchema;
    this.notifications = this.dateTimeData.notifications || [];
  },
  methods: {
    addNewNotification() {
      const notificationSchema = cloneDeep(this.notificationSchema);
      notificationSchema.notificationConditionFlag = false;
      notificationSchema.notificationContactFlag = false;
      this.notifications.push(notificationSchema);
      this.hideAddNotification = !this.hideAddNotification;
    },

    saveNotification(index) {
      this.notifications[index].notificationContactFlag = false;
      this.notifications[index].notificationConditionFlag = false;
      const selectedContactsList = filter(this.notifications[index].contacts, "status", true);
      let modeOfNotificationErroCount = 0;
      selectedContactsList.forEach(contact => {
        if (!contact.sms && !contact.email) {
          modeOfNotificationErroCount += 1;
        }
      });
      if (!this.notifications[index].triggerCondition.selectedOptionVal) {
        this.notifications[index].notificationConditionFlag = true;
      } else if (filter(this.notifications[index].contacts, "status", true).length <= 0) {
        this.notifications[index].notificationContactFlag = true;
      } else if (modeOfNotificationErroCount > 0) {
        const selectedContacts = filter(this.notifications[index].contacts, "status", true);
        selectedContacts.forEach(contact => {
          if (!contact.sms && !contact.email) {
            this.notifications[index].notificationContactFlag = true;
          }
        });
      } else {
        this.notifications[index].mode = !this.notifications[index].mode;
        this.hideAddNotification = !this.hideAddNotification;
        this.choicesGiven[index].disabled = true;
        this.dateTimeData.notifications = this.notifications;
        this.dateTimeData.notifications[index].name = `${this.dateTimeData.notifications[index].name} ${index + 1}`;
      }
    },

    removeNotification(index) {
      this.choicesGiven[index].disabled = false;
      this.dateTimeData.notifications.splice(index, 1);
      const tempNotifications = this.dateTimeData.notifications;
      this.dateTimeData.notifications = [];
      tempNotifications.forEach((notification, ind) => {
        const tempNotification = notification;
        tempNotification.name = `Notification ${ind + 1}`;
        this.dateTimeData.notifications.push(tempNotification);
      });
    },

    addContact(index) {
      this.dateTimeData.notifications[index].contacts.push({
        status: true,
        name: "Sari Patel(PhV)",
        email: false,
        sms: false
      });
    },

    findOptionVal(index, optIndex) {
      // find choice selected from available choice
      // then store that choice value in notification data
      if (!this.dateTimeData.choices[findIndex(this.dateTimeData.choices, ["index", optIndex])]) {
        this.dateTimeData.notifications[index].triggerCondition.selectedOptionVal = "";
      } else {
        this.dateTimeData.notifications[index].triggerCondition.selectedOptionVal = this.dateTimeData.choices[findIndex(this.dateTimeData.choices, ["index", optIndex])].value;
      }
    },

    checkForErrors() {
      if (this.dateTimeData.fieldName && this.dateTimeData.fieldName.trimEnd().length > 0) {
        this.dateTimeData.fieldNameErrorMsg = "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.text-align {
  line-height: 23px !important;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.is-danger {
  border-color: #ff4848;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div {
  background-color: #1e8fe1;
  height: 9px;
  width: 33px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
  margin-left: -15px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div {
  background-color: #d5d7dc;
  height: 9px;
  width: 33px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
}
</style>
